"use strict";
exports.__esModule = true;
exports.profileMode = exports.isNotTransits = exports.isRelocation = exports.isPrognostics = exports.isSynastry = exports.getObjectName = exports.getDir = exports.isPersonal = exports.hasObject = exports.getOpponent = exports.objectSign = exports.getHouseControllers = exports.findOppositePlanets = exports.filterAspectsByObjectAndTypes = exports.filterAspectsByType = exports.filterAspectsByObject = exports.getHouseObjects = exports.getObjectHouses = exports.getSign = exports.getDirections = exports.directionShift = void 0;
var averageDaysInTropicalYear = 365.2422;
var secsInYear = averageDaysInTropicalYear * 24 * 3600;
var constants_1 = require("./constants");
var defs_1 = require("./defs");
var utils_1 = require("./utils");
function directionShift(o, shift) {
    return {
        lon: (0, utils_1.circular)(o.lon + shift, 360),
        speed: shift / secsInYear
    };
}
exports.directionShift = directionShift;
function getDirections(natal, natalDate, progDate) {
    var shift = (new Date(progDate).valueOf() - new Date(natalDate).valueOf()) / secsInYear / 1000;
    return {
        houses: natal.houses.map(function (h) { return (0, utils_1.circular)(h + shift, 360); }),
        objects: natal.objects.map(function (o) { return directionShift(o, shift); }),
        shift: shift
    };
}
exports.getDirections = getDirections;
function getSign(lon) {
    return Math.floor(lon / 30) % 12;
}
exports.getSign = getSign;
function getObjectHouses(lon, houses, strict) {
    var result = [];
    for (var h = 0; h < houses.length; h++) {
        var nextH = (h + 1) % 12;
        var tlon = Math.ceil(lon);
        var lonH = Math.ceil(houses[h]);
        var lonNH = Math.ceil(houses[nextH]);
        if (lonNH < lonH) {
            if (tlon <= lonNH) {
                tlon += 360;
            }
            lonNH += 360;
        }
        if (!strict) {
            var diff = lonNH - tlon;
            if (diff > 0 &&
                diff <= 4) {
                result.push(nextH);
            }
        }
        if (tlon >= lonH && tlon < lonNH) {
            result.push(h);
            break;
        }
    }
    return result.sort(function (a, b) { return b - a; });
}
exports.getObjectHouses = getObjectHouses;
function getHouseObjects(house, houses, objects, strict) {
    var result = [];
    house -= defs_1.ObjectType.House1;
    for (var obj = 0; obj < objects.length; obj++) {
        if (getObjectHouses(objects[obj].lon, houses, strict).includes(house)) {
            result.push(obj);
        }
    }
    return result;
}
exports.getHouseObjects = getHouseObjects;
function filterAspectsByObject(aspects, object) {
    return aspects
        .filter(function (aspect) {
        return aspect.obj1 === object ||
            aspect.obj2 === object;
    });
}
exports.filterAspectsByObject = filterAspectsByObject;
function filterAspectsByType(aspects, types) {
    return aspects.filter(function (asp) { return types.includes(asp.type); });
}
exports.filterAspectsByType = filterAspectsByType;
function filterAspectsByObjectAndTypes(aspects, obj, types) {
    return aspects.filter(function (a) { return types.includes(a.type) && hasObject(a, obj); });
}
exports.filterAspectsByObjectAndTypes = filterAspectsByObjectAndTypes;
function findOppositePlanets(planet, aspects) {
    return aspects
        .filter(function (a) { return hasObject(a, planet); })
        .map(function (a) { return a.obj1 === planet ? a.obj2 : a.obj1; });
}
exports.findOppositePlanets = findOppositePlanets;
function getHouseControllers(houses) {
    var result = {};
    var _loop_1 = function (p) {
        var controls = [];
        var houseSign = {};
        for (var sign = 0; sign < 12; sign++) {
            houseSign[sign] = [];
        }
        houses.forEach(function (lon, i) { return houseSign[getSign(lon)].push(i); });
        constants_1.controllers[p]
            .forEach(function (sign) {
            return houseSign[sign]
                .forEach(function (p) { return controls.push(p); });
        });
        result[p] = controls;
    };
    for (var p = defs_1.ObjectType.Sun; p <= defs_1.ObjectType.Pluto; p++) {
        _loop_1(p);
    }
    return result;
}
exports.getHouseControllers = getHouseControllers;
function objectSign(object, data) {
    return getSign(data.objects[object].lon);
}
exports.objectSign = objectSign;
function getOpponent(aspect, object) {
    return aspect.obj1 === object ? aspect.obj2 : aspect.obj1;
}
exports.getOpponent = getOpponent;
function hasObject(a, obj) {
    return a.obj1 === obj || a.obj2 === obj;
}
exports.hasObject = hasObject;
function isPersonal(obj, data) {
    var aspects = data.aspects.filter(function (a) { return constants_1.majorAspects.includes(a.type); });
    return (obj <= defs_1.ObjectType.Mars ||
        obj === constants_1.dispositors[0][0] ||
        findOppositePlanets(obj, aspects).some(function (op) { return op <= defs_1.ObjectType.Mars; }) ||
        getObjectHouses(data.objects[obj].lon, data.houses, false).includes(0));
}
exports.isPersonal = isPersonal;
function getDir(v) {
    return Math.abs(v) < 0.0003 ? 0 : (v < 0 ? -1 : 1);
}
exports.getDir = getDir;
function getObjectName(obj, locale) {
    if (locale === void 0) { locale = 'ru'; }
    return obj < defs_1.ObjectType.House1 ?
        constants_1.astroObjects[obj][locale] :
        constants_1.houseNames[obj - defs_1.ObjectType.House1];
}
exports.getObjectName = getObjectName;
function isMode(modes, isModes) {
    var is = function (m) { return isModes.includes(m); };
    return typeof modes === 'string' ? is(modes) : modes.some(is);
}
function isSynastry(modes) {
    var is = function (m) { return /^syn_natal|partner\d+|compatibility\d*$/.test(m); };
    return typeof modes === 'string'
        ? is(modes)
        : modes.some(is);
}
exports.isSynastry = isSynastry;
function isPrognostics(modes) {
    return isMode(modes, constants_1.prognosticsModes);
}
exports.isPrognostics = isPrognostics;
function isRelocation(modes) {
    return isMode(modes, constants_1.relocationsModes);
}
exports.isRelocation = isRelocation;
function isNotTransits(mode) {
    return mode === 'solars' || mode === 'directions' || mode === 'prog_prog' || mode === 'prog_natal';
}
exports.isNotTransits = isNotTransits;
function profileMode(mode) {
    if (mode === 'syn_natal' ||
        mode.startsWith('partner') ||
        mode.startsWith('relocation'))
        return 'natal';
    if (mode.startsWith('compatibility'))
        return 'synastry';
    if (mode.startsWith('prog'))
        return 'progressions';
    return mode;
}
exports.profileMode = profileMode;
